import React from "react";

import Banner from "./Banner";
import Employees from "./Employees";
import PopupNotices from "./PopupNotices";
import { Divider } from "antd";

const Home = () => {
  return (
    <div className="page-wrapper">
      <h2 style={{ fontWeight: "bold", marginBottom: "24px" }}>Home page</h2>
      <Banner />
      <Divider style={{ marginTop: "2.5rem", marginBottom: "2.5rem" }} />
      <Employees />
      <Divider style={{ marginTop: "2.5rem", marginBottom: "2.5rem" }} />
      <PopupNotices />
    </div>
  );
};

export default Home;
